import React from 'react'
import api from '../../utils/api'
import Heading from 'shared/ui/Heading'
import { SimpleForm, Field } from 'shared/ui/SimpleForm'

export default function GeneralContactForm() {
  function onSubmit({ name, email, message }) {
    return api.sendGeneralContactForm(name, email, message)
  }

  return (
    <div className="spacing">
      <Heading size={2}>Contact Us</Heading>
      <SimpleForm onSubmit={onSubmit}>
        <Field name="name" label="Full Name" placeholder="Jane Doe" required />
        <Field name="email" type="email" label="Email" placeholder="jane@email.com" required />
        <Field label="Message" name="message">
          <textarea
            name="message"
            placeholder="What questions do you have? Tell us what you're looking for!"
            className="form-field"
          />
        </Field>
        <footer className="spacing">
          <button type="submit" className="button block">
            Send Message
          </button>
          <div className="text-small">
            Or email us at <a href="mailto:hello@reacttraining.com">hello@reacttraining.com</a>
          </div>
        </footer>
      </SimpleForm>
    </div>
  )
}
